import * as React from 'react';

export function Toolbar({ children }: { children?: React.ReactNode }) {
  return (
    <div className="relative flex min-h-[56px] items-center justify-center py-3">{children}</div>
  );
}
